import { createSlice } from "@reduxjs/toolkit";

const treeAndSearchSlice = createSlice({
    name: "DeviceTree/Search",
    initialState: {
        searchedOrClickedToiletNodeID: '',
        openToiletNodesID: [],
    },
    reducers: {

        setSearchedOrClickedToiletNode: (state, action) => {
            state.searchedOrClickedToiletNodeID = action.payload;
        },


        addToOpenToiletNodes: (state, action) => {
            let currentOpenedToiletsArr = state.openToiletNodesID;
            if(!currentOpenedToiletsArr.includes(action.payload)) {
                currentOpenedToiletsArr.push(action.payload)
            }
            state.openToiletNodesID = currentOpenedToiletsArr;
        },

        toggleToiletNodeInOpenToiletNodes: (state, action) => {
            const toiletID = action.payload;

            if (state.openToiletNodesID.includes(toiletID)) {
                // Collapse
                state.openToiletNodesID = state.openToiletNodesID.filter(id => id !== toiletID);
            } else {
                // Expand
                state.openToiletNodesID = [...state.openToiletNodesID, toiletID];
            }
        },

        clearSearchOrClickedToiletNode: (state) => {
            if(state.searchedOrClickedToiletNodeID != null && state.searchedOrClickedToiletNodeID.length > 0) {
                state.searchedOrClickedToiletNodeID = ''
            }
        },

        clearOpenToiletNodes: (state) => {
            if(state.openToiletNodesID != null && state.openToiletNodesID.length > 0) {
                state.openToiletNodesID = []
            }
        }
    }
});

export const { setSearchedOrClickedToiletNode, addToOpenToiletNodes, toggleToiletNodeInOpenToiletNodes, clearSearchOrClickedToiletNode, clearOpenToiletNodes } = treeAndSearchSlice.actions;

export default treeAndSearchSlice.reducer;
